import {InterfacePartnersTemplate} from "../../../interface/elements-with-filter/interface.partners-template";
import {webApi} from "../../consts";

export const partnersTemplateHtml = (units: InterfacePartnersTemplate[]): string => {
    let contentResult = '';
    units.forEach((item: InterfacePartnersTemplate): void => {
        contentResult
            += `
                <div class="our-partners__unit">
                    <div class="our-partners__unit-image">
                        <img src="${webApi}${item.ImgUrl}" alt="partner">
                    </div>
                    <div class="our-partners__unit-text">
                        <div>
                            <div class="our-partners__unit-text-title">
                                <h4 class="mb-10">${item.Header}</h4>
                            </div>
                            <a class="mb-25" href="//${item.Link}" target="_blank">${item.Link}</a>
                            <div class="our-partners__unit-text-description">
                                <p class="mb-25" data-switcher-content="default-height">
                                    ${item.Body.replace(/<[^>]*>/g, "")}
                                </p>
                            </div>
                        </div>
                        <div class="our-partners__btn-content-toggle control-area" data-switcher-control>
                            <a href="javaScript:void(0);" class="control-area__toggle-text">
                                <span>Показать больше</span>
                                <span>Скрыть</span>
                            </a>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="8" viewBox="0 0 15 8"
                                 fill="none">
                                <path d="M1.5 1L7.5 7L13.5 1" stroke="#1D1C1C" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            `
    });
    return contentResult;
}
